import classNames from '@ui-components-3/ui/lib/utils/classNames'
import AlarmSnoozeIcon from '@ui-components-3/icons/lib/solid/AlarmSnooze'
import Menu from '@ui-components-3/ui/lib/components/Menu'

import { HOUR, DAY, TWO_DAYS, WEEK, TWO_WEEKS } from 'constants/snoozeOptions'

import User from 'singletons/User'
import { observer } from 'mobx-react-lite'

// Snooze options
const snoozeMenuOptions = [
  {
    title: 'Turn Off',
    value: null,
    isDanger: true,
  },
  {
    title: HOUR,
    isDanger: false,
  },
  {
    title: DAY,
    isDanger: false,
  },
  {
    title: TWO_DAYS,
    isDanger: false,
  },
  {
    title: WEEK,
    isDanger: false,
  },
  {
    title: TWO_WEEKS,
    isDanger: false,
  },
]

const SnoozeMenu = () => {
  const { provider } = User

  const { notifications } = provider

  const snoozeOptionsToRender = notifications.snooze ? snoozeMenuOptions : snoozeMenuOptions.slice(1)

  return (
    <Menu
      className='outline-none'
      prefix={
        <div className='p-3 border-b border-b-neutral-300'>
          <p className='typography-body-l'>Snoozed until...</p>
          {notifications.snooze && (
            <p className='typography-body font-medium'>{new Date(notifications.snooze).toLocaleString()}</p>
          )}
        </div>
      }
      items={snoozeOptionsToRender.map(({ title, isDanger }) => (
        <button
          type="button"
          className={isDanger ? 'text-fuchsia-800' : 'text-neutral-800'}
          onClick={() => provider.changeSnoozeStatus(title)}
        >
          {title}
        </button>
      ))}
      itemClassName='w-[215px] typography-body-l !px-2 my-1'
      aria-label="Snooze menu"
    >
      <AlarmSnoozeIcon
        className={classNames('w-7 h-7', notifications.snooze ? 'text-primary-400' : 'text-neutral-400')}
        aria-hidden="true"
      />
    </Menu>
  )
}

export default observer(SnoozeMenu)
